(function () {
  'use strict';

  const RESTRICTED_SKUS = [
  'H-DP-TP-MC-550-01',
  'H-CS-MC-550-WM-01'
];

  async function getCart() {
    const response = await fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Unable to fetch cart');
    }

    return await response.json();
  }

  function showRestrictionMessage(sku) {
    alert(
    //   'This product (' + sku + ') can only be added once per order.'/
    'This product can only be added once per order.'
    );
  }

  async function checkRestrictedSKU(variantId, requestedQuantity) {
    const cart = await getCart();

    // Find the variant being added from Shopify product data
    let variantSKU = null;

    try {
      const response = await fetch(
        window.Shopify.routes.root + 'products.json?limit=250'
      );

      if (response.ok) {
        const data = await response.json();

        for (const product of data.products || []) {
          const variant = product.variants.find(
            v => Number(v.id) === Number(variantId)
          );

          if (variant) {
            variantSKU = variant.sku;
            break;
          }
        }
      }
    } catch (error) {
      console.warn('Could not identify SKU:', error);
    }

    // If this is not a restricted SKU, allow normally
    if (!RESTRICTED_SKUS.includes(variantSKU)) {
      return true;
    }

    // Check if restricted SKU already exists
    const existingItem = cart.items.find(
      item => item.sku === variantSKU
    );

    if (existingItem) {
      showRestrictionMessage(variantSKU);
      return false;
    }

    // Do not allow quantity greater than 1
    if (Number(requestedQuantity) > 1) {
      showRestrictionMessage(variantSKU);
      return false;
    }

    return true;
  }

  /*
   * Intercept Shopify Add to Cart forms
   */
  document.addEventListener('submit', async function (event) {
    const form = event.target;

    if (!form || !form.action) return;

    const action = form.action;

    if (
      !action.includes('/cart/add') &&
      !action.includes('/cart/add.js')
    ) {
      return;
    }

    const variantInput = form.querySelector(
      '[name="id"], input[name="id"]'
    );

    const quantityInput = form.querySelector(
      '[name="quantity"], input[name="quantity"]'
    );

    if (!variantInput) return;

    const variantId = variantInput.value;
    const quantity = quantityInput
      ? Number(quantityInput.value || 1)
      : 1;

    event.preventDefault();
    event.stopImmediatePropagation();

    try {
      const allowed = await checkRestrictedSKU(
        variantId,
        quantity
      );

      if (!allowed) {
        return;
      }

      // Submit the form normally after validation
      form.submit();

    } catch (error) {
      console.error(
        'Restricted SKU validation error:',
        error
      );

      // Allow normal Shopify behaviour if validation fails
      form.submit();
    }
  }, true);


  /*
   * Intercept Ajax / Fetch Add to Cart
   * Useful for custom Shopify + Shiprocket cart implementations.
   */
  const originalFetch = window.fetch;

  window.fetch = async function () {
    const args = arguments;
    const url = args[0];

    let requestURL = '';

    if (typeof url === 'string') {
      requestURL = url;
    } else if (url && url.url) {
      requestURL = url.url;
    }

    // Only check Shopify Ajax Add to Cart
    if (
      requestURL.includes('/cart/add.js') ||
      requestURL.includes('/cart/add')
    ) {
      try {
        let body = args[1] && args[1].body;

        if (body) {
          let parsedBody = null;

          if (typeof body === 'string') {
            try {
              parsedBody = JSON.parse(body);
            } catch (e) {
              // FormData / URL encoded request
            }
          }

          if (parsedBody) {
            let items = parsedBody.items;

            if (!items && parsedBody.id) {
              items = [
                {
                  id: parsedBody.id,
                  quantity: parsedBody.quantity || 1
                }
              ];
            }

            if (items && items.length) {
              for (const item of items) {
                const allowed = await checkRestrictedSKU(
                  item.id,
                  item.quantity || 1
                );

                if (!allowed) {
                  return new Response(
                    JSON.stringify({
                      status: 422,
                      message:
                        'This product can only be added once per order.'
                    }),
                    {
                      status: 422,
                      headers: {
                        'Content-Type': 'application/json'
                      }
                    }
                  );
                }
              }
            }
          }
        }
      } catch (error) {
        console.error(
          'Restricted cart validation:',
          error
        );
      }
    }

    return originalFetch.apply(this, args);
  };

})();